var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgP01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102.8413 146.3345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,146.3345V0H57.1113Q77.74,0,90.291,10.9243q12.5493,10.9248,12.55,30.74T90.291,72.4053Q77.7389,83.33,57.1113,83.33h-37.6v63.0049ZM19.5117,65.8506H55.0791q13.3118,0,20.7817-5.7925T83.33,41.6646q0-12.7017-7.4693-18.4444-7.4693-5.74-20.7817-5.7412H19.5117Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,146.3345V0H57.1113Q77.74,0,90.291,10.9243q12.5493,10.9248,12.55,30.74T90.291,72.4053Q77.7389,83.33,57.1113,83.33h-37.6v63.0049ZM19.5117,65.8506H55.0791q13.3118,0,20.7817-5.7925T83.33,41.6646q0-12.7017-7.4693-18.4444-7.4693-5.74-20.7817-5.7412H19.5117Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP01);
export default __webpack_public_path__ + "static/media/p-01.757ba3663125289559c13e2e33717315.svg";
export { ForwardRef as ReactComponent };